import { logoUrl, API_BASE } from "@/lib/api";

export const CoverPage = ({ study, client, settings, basePath = "/studies" }) => {
  const inp = study.input;
  const photos = study.site_data?.photos || [];
  const idx = study.cover_photo != null && study.cover_photo < photos.length ? study.cover_photo : 0;
  const template = settings?.cover_template || "framed";
  const photo = template === "logo" ? null : photos[idx];
  const full = template === "full";
  const meta = [inp.industry, study.verdict && `Verdict: ${study.verdict}`, study.score != null && `Feasibility score: ${study.score}/100`].filter(Boolean);
  return (
    <div className={`hidden print:flex print-cover flex-col items-center text-center min-h-[95vh] ${full ? "px-6" : "px-14"} pt-10 pb-12`} data-testid="pdf-cover" data-template={template}>
      <div className="flex justify-center w-full">
        {settings?.logo_path ? <img src={logoUrl(settings.logo_path)} alt="Logo" className="max-h-24 max-w-[300px] object-contain mx-auto" /> : <p className="text-2xl font-bold">{settings?.company_name}</p>}
      </div>
      {settings?.tagline && <p className="mt-2 text-[10px] uppercase tracking-[0.2em] text-slate-500" data-testid="pdf-cover-tagline">{settings.tagline}</p>}
      <div className={`w-full flex flex-col items-center ${photo ? "mt-10" : "flex-1 justify-center"}`}>
        {photo && (
          <figure className={`w-full mb-10 ${full ? "" : "max-w-[560px] border p-2"}`} style={full ? undefined : { borderColor: "#000" }} data-testid="pdf-cover-photo">
            <img src={`${API_BASE}${basePath}/${study.id}/photos/${idx}?v=${encodeURIComponent(study.site_data?.fetched_at || "")}`} alt={photo.label}
              className={`w-full object-cover ${full ? "aspect-[16/10]" : "aspect-[8/5]"}`} />
            <figcaption className="mt-2 text-[10px] italic" style={{ color: "#64748b" }}>{photo.label} · © {photo.attribution || "Google"}</figcaption>
          </figure>
        )}
        <p className="text-xs uppercase tracking-[0.35em] font-semibold mb-3" style={{ color: "var(--brand-accent, #059669)" }}>Feasibility Study</p>
        <h1 className={`${photo ? "text-4xl" : "text-5xl"} font-extrabold leading-tight mb-3 max-w-[640px]`} style={{ fontFamily: "Outfit" }}>{inp.project_name}</h1>
        {inp.address && <p className="text-base mb-2">{inp.address}</p>}
        {meta.length > 0 && <p className="text-sm" style={{ color: "#64748b" }}>{meta.join("  ·  ")}</p>}
      </div>
      <div className="mt-auto w-full grid grid-cols-2 gap-8 border-t pt-6 text-sm text-left">
        <div>
          <p className="uppercase tracking-wider text-xs mb-2">Prepared for</p>
          <p className="text-lg font-semibold">{client?.name || "—"}</p>
          {client?.company && <p>{client.company}</p>}
          {client?.address && <p>{client.address}</p>}
        </div>
        <div className="text-right">
          <p className="uppercase tracking-wider text-xs mb-2">Prepared by</p>
          <p className="text-lg font-semibold">{study.prepared_by || "—"}</p>
          <p>{settings?.company_name}</p>
          {settings?.tagline && <p className="text-sm text-slate-500">{settings.tagline}</p>}
          <p>{new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
        </div>
      </div>
    </div>
  );
};
